import React, { Component, Fragment } from 'react';
import Modal from 'react-modal';
import {Icon} from '../../../components/Common/Icon';

import cx from '../../../styles';

const customStyles = {
  content : {
      top                   : '50%',
      left                  : '50%',
      right                 : 'auto',
      bottom                : 'auto',
      marginRight           : '-50%',
      transform             : 'translate(-50%, -50%)'
  }
};

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
if(typeof window != 'undefined') {
    Modal.setAppElement('#root');
}

class ImagePopup extends Component {

    constructor(props) {
        super(props);
        this.state = {isModalOpen: false};
    }

    componentDidMount() {
        this.setState({isModalOpen: this.props.isModalOpen});
    }

    componentWillReceiveProps(nextProps) {
        this.setState({isModalOpen: nextProps.isModalOpen});
    }

    onAfterOpen = () => {
        this.setState({isModalOpen: true});
    }

    onModalClose = () => {
        this.setState({isModalOpen: false});
        if(this.props.onClose) this.props.onClose();
    }

    render() {
        return (
            <Fragment>
                <Modal isOpen={this.state.isModalOpen}
                    onAfterOpen={this.onAfterOpen}
                    onRequestClose={this.onModalClose}
                    overlayClassName="myOverlayClass image-popup-overlay"
                    style={customStyles} >

                    <div className={cx("image-popup")}>
                        

                        <div className={cx("img-wrap")}>
                            <div className={cx('modal-element-align')}>
                                <span className={cx("close-modal")} onClick={this.onModalClose}>
                                    <Icon className={cx("not-mobile")} name="close-regular-white-sm" />
                                    <Icon className={cx("only-mobile")}  name="cross-regular-white-smd" />
                                </span>
                                <a href={this.props.url} className={cx("for-reward-specific-image")}>
                                    <img className={cx("only-mobile")} src={this.props.imgUrlMobile} alt="popup desktop" loading="lazy"/>
                                    <img className={cx("not-mobile")} src={this.props.imgUrlDesktop} alt="popup mobile" loading="lazy"/>
                                </a>
                            </div>
                        </div>                       
                    </div>
                </Modal>
            </Fragment>
        );
    }

}

export default ImagePopup;
